import { useParams } from 'react-router-dom'
import { DineIn } from '../shop/pages'
import { AppContentLoader, LoaderSwitcher } from './loaders'

interface StoreParams extends Record<string, string | undefined> {
  slug: string
}

export const LoadDineIn = () => {
  const { slug } = useParams<StoreParams>()

  if (!slug) {
    throw new Error('Slug parameter is missing in URL')
  }

  return (
    <AppContentLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <DineIn slug={slug} />
        </LoaderSwitcher>
      )}
    </AppContentLoader>
  )
}
